/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateProjectOwnerDto } from '../../models/create-project-owner-dto';
import { ProjectOwnerResponseAdminAdminDto } from '../../models/project-owner-response-admin-admin-dto';

export interface AdminProjectOwnersControllerCreateProjectOwner$Params {
      body: CreateProjectOwnerDto
}

export function adminProjectOwnersControllerCreateProjectOwner(http: HttpClient, rootUrl: string, params: AdminProjectOwnersControllerCreateProjectOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>> {
  const rb = new RequestBuilder(rootUrl, adminProjectOwnersControllerCreateProjectOwner.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProjectOwnerResponseAdminAdminDto>;
    })
  );
}

adminProjectOwnersControllerCreateProjectOwner.PATH = '/admin/project-owners';
